/* eslint-disable jsx-a11y/anchor-is-valid */
import { useState } from 'react'
import { useIntl } from 'react-intl'
import { toast } from 'react-toastify'
import { toAbsoluteUrl } from '../../../../_metronic/helpers'
import { BasicButton } from '../../widgets/components/UI/BasicButton'
import { ToolTipUI } from '../../widgets/components/UI/ToolTipUI'
import { putPaypalReferralEmail } from '../core/_requests'
import Skeleton from 'react-loading-skeleton'
import TagManager from 'react-gtm-module'
import { GTMEvent } from '../../../hooks/gtmHelpers'
import { useAuth } from '../../auth'
import brandingConfig from '../../../../config/brandingConfig'

export function Referral({
  referral,
  totalEarning,
  totalReferred,
  setPaypalId,
  paypalId,
}: {
  paypalId?: string
  referral?: string
  totalEarning?: string
  totalReferred?: string
  setPaypalId: React.Dispatch<React.SetStateAction<string | undefined>>
}) {
  const { formatMessage } = useIntl()
  const [loading, setLoading] = useState(false)
  const { currentUser, companyId } = useAuth()

  const addPaypalEmail = async () => {
    try {
      setLoading(true)
      const {
        data: { success, errors },
      } = await putPaypalReferralEmail({
        paypalEmail: paypalId,
      })

      if (success) {
        setLoading(false)
        toast.success(formatMessage({ id: 'Paypal email updated' }))
        TagManager.dataLayer({
          dataLayer: {
            event: GTMEvent.UpdatePaypalReferralEmailSuccessful,
            action: 'normal',
            metadata: {
              paypal_email: paypalId,
              user_id: currentUser?.userId,
              email: currentUser?.email,
              company_id: companyId,
            },
          },
        })
      } else {
        setLoading(false)
        errors.forEach((error: string) => {
          toast.error(formatMessage({ id: error }))
        })
        TagManager.dataLayer({
          dataLayer: {
            event: GTMEvent.UpdatePaypalReferralEmailFailed,
            action: 'normal',
            metadata: {
              paypal_email: paypalId,
              user_id: currentUser?.userId,
              email: currentUser?.email,
              company_id: companyId,
              error: errors[0],
            },
          },
        })
      }
    } catch (err) {
      setLoading(false)
      console.log(err)
      TagManager.dataLayer({
        dataLayer: {
          event: GTMEvent.UpdatePaypalReferralEmailFailed,
          action: 'normal',
          metadata: {
            paypal_email: paypalId,
            user_id: currentUser?.userId,
            email: currentUser?.email,
            company_id: companyId,
            error: err,
          },
        },
      })
    }
  }

  return (
    <>
      <div className='card rounded-1 p-2'>
        <div className='card-body'>
          {loading ? (
            <>
              <div className='w-100'>
                <div>
                  <div>
                    <Skeleton
                      width={250}
                      height={30}
                      baseColor='var(--kt-skeleton-bg-color)'
                      highlightColor='var(--kt-skeleton-highlight-bg-color)'
                    />
                  </div>
                  <div className='w-75 mt-1'>
                    <Skeleton
                      height={15}
                      baseColor='var(--kt-skeleton-bg-color)'
                      highlightColor='var(--kt-skeleton-highlight-bg-color)'
                    />
                  </div>
                </div>
                <div>
                  <div className='col-12 d-md-flex mt-md-8 gap-md-20'>
                    <div className='col-md-4 col-12 mt-3 mt-md-0'>
                      <div className='w-md-50 w-75 mb-1'>
                        <Skeleton
                          height={15}
                          baseColor='var(--kt-skeleton-bg-color)'
                          highlightColor='var(--kt-skeleton-highlight-bg-color)'
                        />
                      </div>
                      <div>
                        <Skeleton
                          height={30}
                          baseColor='var(--kt-skeleton-bg-color)'
                          highlightColor='var(--kt-skeleton-highlight-bg-color)'
                        />
                      </div>
                    </div>
                    <div className='col-md-4 col-12 mt-3 mt-md-0'>
                      <div className='w-md-50 w-75 mb-1'>
                        <Skeleton
                          height={15}
                          baseColor='var(--kt-skeleton-bg-color)'
                          highlightColor='var(--kt-skeleton-highlight-bg-color)'
                        />
                      </div>
                      <div>
                        <Skeleton
                          height={30}
                          baseColor='var(--kt-skeleton-bg-color)'
                          highlightColor='var(--kt-skeleton-highlight-bg-color)'
                        />
                      </div>
                    </div>
                    <div className='col-md-2 col-12 mt-3 mt-md-0'>
                      <div className='mb-1'>
                        <Skeleton
                          height={15}
                          baseColor='var(--kt-skeleton-bg-color)'
                          highlightColor='var(--kt-skeleton-highlight-bg-color)'
                        />
                      </div>
                      <div className='d-flex w-100 gap-2'>
                        <div className='w-25'>
                          <Skeleton
                            height={30}
                            baseColor='var(--kt-skeleton-bg-color)'
                            highlightColor='var(--kt-skeleton-highlight-bg-color)'
                          />
                        </div>
                        <div className='w-25'>
                          <Skeleton
                            height={30}
                            baseColor='var(--kt-skeleton-bg-color)'
                            highlightColor='var(--kt-skeleton-highlight-bg-color)'
                          />
                        </div>
                        <div className='w-25'>
                          <Skeleton
                            height={30}
                            baseColor='var(--kt-skeleton-bg-color)'
                            highlightColor='var(--kt-skeleton-highlight-bg-color)'
                          />
                        </div>
                        <div className='w-25'>
                          <Skeleton
                            height={30}
                            baseColor='var(--kt-skeleton-bg-color)'
                            highlightColor='var(--kt-skeleton-highlight-bg-color)'
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className='row mt-md-8 mt-3'>
                    <div className='col-lg-2 col-xl-2 col-md-2 col-12 card'>
                      <Skeleton
                        height={130}
                        baseColor='var(--kt-skeleton-bg-color)'
                        highlightColor='var(--kt-skeleton-highlight-bg-color)'
                      />
                    </div>
                    <div className='col-lg-2 col-xl-2 col-md-2 col-12 card mt-3 mt-md-0'>
                      <Skeleton
                        height={130}
                        baseColor='var(--kt-skeleton-bg-color)'
                        highlightColor='var(--kt-skeleton-highlight-bg-color)'
                      />
                    </div>
                  </div>
                  <div className='col-12 d-md-flex mt-md-8 gap-md-20 mt-3'>
                    <div className='col-md-4 col-12'>
                      <div className='w-md-50 w-75 mb-1'>
                        <Skeleton
                          height={15}
                          baseColor='var(--kt-skeleton-bg-color)'
                          highlightColor='var(--kt-skeleton-highlight-bg-color)'
                        />
                      </div>
                      <div className='d-md-flex w-100 gap-2'>
                        <div className='w-md-75 w-100'>
                          <Skeleton
                            height={30}
                            baseColor='var(--kt-skeleton-bg-color)'
                            highlightColor='var(--kt-skeleton-highlight-bg-color)'
                          />
                        </div>
                        <div className='w-md-25 w-100 mt-2 mt-md-0'>
                          <Skeleton
                            height={30}
                            baseColor='var(--kt-skeleton-bg-color)'
                            highlightColor='var(--kt-skeleton-highlight-bg-color)'
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </>
          ) : (
            <>
              <div className=''>
                <h4 className='card-label'>
                  {formatMessage({ id: 'Invite Friends & Start Earning' })}
                </h4>
                <p className='pb-4'>
                  {formatMessage({
                    id: `Invite a friend to ${brandingConfig.brandName}, and enjoy a lifetime of earnings from their activity.`,
                  })}
                </p>
              </div>
              <div>
                <div className='col-12  row'>
                  <div className='col-lg-5 col-md-5 col-xl-5 col-12 pe-2'>
                    <div className='input-group border-right-0 '>
                      <label className='col-12 mb-2'>
                        {formatMessage({ id: 'Referral Link' })}{' '}
                        <ToolTipUI
                          tooltipText={formatMessage({ id: 'Find your referral link here' })}
                        />
                      </label>
                      <input
                        type='text'
                        className='form-control '
                        value={`${window.location.protocol}//${window.location.hostname}/auth/registration?r=${referral}`}
                        placeholder={formatMessage({ id: 'Some path' })}
                        readOnly
                      />
                      <span
                        className='input-group-btn border border-left-0'
                        style={{ borderColor: '#e4e6ef !important' }}
                        onClick={() => {
                          navigator.clipboard.writeText(
                            `${window.location.protocol}//${window.location.hostname}/auth/registration?r=${referral}`
                          )
                          toast.success(formatMessage({ id: 'Copied Successfully' }))
                        }}
                      >
                        <i className='fa fa-copy  btn'></i>
                      </span>
                    </div>
                  </div>
                  <div className='col-lg-5 col-md-5 col-xl-5 col-12'>
                    <div className='input-group border-right-0'>
                      <label className='col-12 mb-2'>
                        {formatMessage({ id: 'Referral Code' })}{' '}
                        <ToolTipUI
                          tooltipText={formatMessage({ id: 'Find your referral code here' })}
                        />
                      </label>
                      <input
                        type='text'
                        className='form-control '
                        value={referral}
                        placeholder='Some path'
                        // id='copy-input'
                        readOnly
                      />
                      <span
                        className='input-group-btn border border-left-0'
                        style={{ borderColor: '#e4e6ef !important' }}
                        onClick={() => {
                          navigator.clipboard.writeText(`${referral}`)
                          toast.success(formatMessage({ id: 'Copied Successfully' }))
                        }}
                      >
                        <i className='fa fa-copy btn'></i>
                      </span>
                    </div>
                  </div>

                  <div className='align-self-center col-lg-2 col-md-2 col-xl-2 col-12 d-flex flex-column px-4'>
                    <div>
                      <label className=''>
                        {formatMessage({ id: 'Share' })}{' '}
                        <ToolTipUI
                          tooltipText={formatMessage({
                            id: `Click here to spread word about ${brandingConfig.brandName} and earn through your referral`,
                          })}
                        />
                      </label>
                    </div>
                    <div className='d-flex py-4'>
                      <span
                        className={`svg-icon svg-icon-1 cursor-pointer`}
                        onClick={() =>
                          window.open(
                            `https://wa.me/?text=You are invited to join ${brandingConfig.brandName}. Please follow my referral link to signup: ${window.location.protocol}//${window.location.hostname}/auth/registration?r=${referral}`,
                            '_blank',
                            'noreferrer'
                          )
                        }
                      >
                        <img
                          src={toAbsoluteUrl('/media/svg/social-logos/whatsapp.svg')}
                          height='25px'
                          width='25px'
                          alt='img_icon'
                        />
                      </span>
                      <span
                        className={`svg-icon svg-icon-1 social-media-icon cursor-pointer`}
                        onClick={() =>
                          window.open(
                            `https://telegram.me/share/url?url=${window.location.protocol}//${window.location.hostname}/auth/registration?r=${referral}`,
                            '_blank',
                            'noreferrer'
                          )
                        }
                      >
                        <img
                          src={toAbsoluteUrl('/media/svg/social-logos/telegram.svg')}
                          height='25px'
                          width='25px'
                          alt='img_icon'
                        />
                      </span>
                      <span
                        className={`svg-icon svg-icon-1 social-media-icon cursor-pointer`}
                        onClick={() =>
                          window.open(
                            `https://www.facebook.com/sharer/sharer.php?u=${window.location.protocol}//${window.location.hostname}/auth/registration?r=${referral}`,
                            '_blank',
                            'noreferrer'
                          )
                        }
                      >
                        <img
                          src={toAbsoluteUrl('/media/svg/social-logos/facebook.svg')}
                          height='25px'
                          width='25px'
                          alt='img_icon'
                        />
                      </span>
                      <span
                        className={`svg-icon svg-icon-1 social-media-icon cursor-pointer`}
                        onClick={() =>
                          window.open(
                            `https://twitter.com/intent/tweet?url=${window.location.protocol}//${window.location.hostname}/auth/registration?r=${referral}`,
                            '_blank',
                            'noreferrer'
                          )
                        }
                      >
                        <img
                          src={toAbsoluteUrl('/media/svg/social-logos/twitter.svg')}
                          height='25px'
                          width='25px'
                          alt='img_icon'
                        />
                      </span>
                      {/* <span
                    className={`svg-icon svg-icon-1 social-media-icon cursor-pointer`}
                    onClick={() =>
                      window.open(
                        `https://www.linkedin.com/sharing/share-offsite/?url=${window.location.protocol}//${window.location.hostname}/auth/registration?r=${referral}`,
                        '_blank',
                        'noreferrer'
                      )
                    }
                  >
                    <img
                      src={toAbsoluteUrl('/media/svg/social-logos/linkedin.svg')}
                      height='25px'
                      width='25px'
                      alt='img_icon'
                    />
                  </span> */}
                    </div>
                  </div>
                </div>
                <div className='row py-2 mt-4'>
                  <div className='col-lg-2 col-xl-2 col-md-2 col-12 card border p-4 m-2'>
                    <img
                      src={toAbsoluteUrl('/media/icons/setting/hand_holding.svg')}
                      alt=''
                      className='button-icon'
                    />
                    <h4>{`$${totalEarning}`}</h4>
                    <p>{formatMessage({ id: 'Total Referral earning' })}</p>
                  </div>
                  <div className='col-lg-2 col-xl-2 col-md-2 col-12 card border p-4  m-2'>
                    <img
                      src={toAbsoluteUrl('/media/icons/setting/people.svg')}
                      alt=''
                      className='button-icon'
                    />
                    <h4>{totalReferred}</h4>
                    <p>{formatMessage({ id: 'Total Referred Companies' })}</p>
                  </div>{' '}
                </div>

                <div className='row'>
                  <div className='col-md-5'>
                    <div className='row mt-4'>
                      <div className='col-md-12'>
                        <label className=''>
                          {formatMessage({ id: 'Your PayPal ID for referral earning payout' })}{' '}
                          <ToolTipUI
                            tooltipText={formatMessage({
                              id: 'Add your PayPal account ID here',
                            })}
                          />
                        </label>
                      </div>
                      <div className='col-md-12 mt-3'>
                        <div className='row d-flex align-items-center'>
                          <div className='col-md-8'>
                            <div className='form-group'>
                              <input
                                type='email'
                                className='form-control'
                                placeholder='mypaypalid@paypal.com'
                                onChange={(e) => setPaypalId(e.target.value)}
                                value={paypalId}
                              />
                            </div>
                          </div>
                          <div className='col-md-4'>
                            <BasicButton
                              disabled={loading}
                              loading={loading}
                              buttonText={formatMessage({ id: 'Save' })}
                              height='36px'
                              border='none'
                              color='#4776E6'
                              textColor='#FFFFFF'
                              minWidth={80}
                              padding='8px 24px'
                              onClick={addPaypalEmail}
                              customClass='w-md-auto w-100 mt-2 mt-md-auto'
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </>
          )}
        </div>
      </div>
    </>
  )
}

/* eslint-disable jsx-a11y/anchor-is-valid */
